class Clock {
    get_current_timestamp_in_millis() {
        return Date.now()
    }
}

export default Clock
